module.exports = __webpack_public_path__ + "static/media/logs-history.c63b30d0.svg";